import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { DollarSignIcon, DownloadIcon, CreditCardIcon, TrendingUpIcon } from 'lucide-react';
import BackButton from '../../components/UI/BackButton';
const Royalties = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const payouts = [{
    id: 'PAY-001',
    date: 'Oct 01, 2023',
    amount: '$1,245.00',
    status: 'Paid',
    method: 'Direct Deposit'
  }, {
    id: 'PAY-002',
    date: 'Sep 01, 2023',
    amount: '$980.50',
    status: 'Paid',
    method: 'Direct Deposit'
  }, {
    id: 'PAY-003',
    date: 'Aug 01, 2023',
    amount: '$1,105.25',
    status: 'Paid',
    method: 'Direct Deposit'
  }];
  return <div className={`min-h-screen py-8 ${dk.page}`} data-id="element-21551" data-mp="cu851e28n4ly">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21552" data-mp="1s7pgxpmhghdv">
        <div className="mb-4" data-id="element-21553" data-mp="1s98ydjjvkyh8">
          <BackButton data-id="element-21554" data-mp="1sa24qjex9lyu" />
        </div>
        <h1 className={`text-3xl font-bold mb-8 ${dk.textHeading}`} data-id="element-21555" data-mp="1x5zf893i7y3p">
          Royalties & Payouts
        </h1>

        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-21556" data-mp="227yhtgrf6qzl">
          {[{
          label: 'Available Balance',
          value: '$450.00',
          sub: 'Next payout: Nov 1, 2023',
          subColor: 'text-green-500'
        }, {
          label: 'Total Earnings (YTD)',
          value: '$12,450.00',
          sub: '+15% vs last year',
          subColor: 'text-green-500',
          trend: true
        }, {
          label: 'Pending Sales',
          value: '$125.50',
          sub: 'Clearing in 3-5 days',
          subColor: dk.textMuted
        }].map(({
          label,
          value,
          sub,
          subColor,
          trend
        }) => <div key={label} className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-21557" data-mp="zr4ngb1p5hbp">
              <p className={`text-sm font-medium ${dk.textMuted}`} data-id="element-21558" data-mp="utcqh2m7350n">{label}</p>
              <h2 className={`text-3xl font-bold mt-2 ${dk.textPrimary}`} data-id="element-21559" data-mp="18k7wm75b780j">
                {value}
              </h2>
              <div className={`flex items-center mt-1 text-sm ${subColor}`} data-id="element-21560" data-mp="13rwy98q7vua3">
                {trend && <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-21561" data-mp="1ih2watdbjege" />}
                <span data-id="element-21562" data-mp="1ijp50wby4007">{sub}</span>
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-21563" data-mp="1dl5esjqbk221">
          {/* Payout History */}
          <div className="lg:col-span-2" data-id="element-21564" data-mp="1rg7w030m9du5">
            <div className={`rounded-xl shadow-sm overflow-hidden border ${dk.card}`} data-id="element-21565" data-mp="1ngpap64vv0qs">
              <div className={`px-6 py-4 border-b flex justify-between items-center ${dk.border}`} data-id="element-21566" data-mp="3taoxb39t5d6b">
                <h2 className={`text-lg font-bold ${dk.textPrimary}`} data-id="element-21567" data-mp="3paev81p4z6wq">
                  Payout History
                </h2>
                <button className={`flex items-center text-sm font-medium ${rt.accentLink}`} data-id="element-21568" data-mp="3j5qr1twckc2i">
                  <DownloadIcon className="h-4 w-4 mr-1" data-id="element-21569" data-mp="35dixeb0d1181" />
                  Export CSV
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-21570" data-mp="3abu80nyhbfrb">
                <table className={`min-w-full divide-y ${dk.divider}`} data-id="element-21571" data-mp="2vfwdfa47ejh7">
                  <thead className={darkMode ? 'bg-gray-750' : 'bg-gray-50'} data-id="element-21572" data-mp="2viqviuzqvs7g">
                    <tr data-id="element-21573" data-mp="30gselfx67rix">
                      {['Date', 'Amount', 'Method', 'Status'].map(h => <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-21574" data-mp="2mhstujcs3ws1">
                          {h}
                        </th>)}
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${dk.divider}`} data-id="element-21575" data-mp="2lqkjpd3dyttf">
                    {payouts.map(payout => <tr key={payout.id} data-id="element-21576" data-mp="2gqzmp87s0vjc">
                        <td className={`px-6 py-4 whitespace-nowrap text-sm ${dk.textPrimary}`} data-id="element-21577" data-mp="2gs0xdbkvrg0j">
                          {payout.date}
                        </td>
                        <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${dk.textPrimary}`} data-id="element-21578" data-mp="27sw1ye4m82sl">
                          {payout.amount}
                        </td>
                        <td className={`px-6 py-4 whitespace-nowrap text-sm ${dk.textMuted}`} data-id="element-21579" data-mp="1t1nf2cs3kvj5">
                          {payout.method}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-21580" data-mp="1k1i7o2mwlx4z">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-21581" data-mp="1f25kthw18q2e">
                            {payout.status}
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Settings Sidebar */}
          <div className="space-y-6" data-id="element-21582" data-mp="8ke6knjphpyn">
            <div className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-21583" data-mp="8jcohz49w37f">
              <h3 className={`font-bold mb-4 flex items-center ${dk.textPrimary}`} data-id="element-21584" data-mp="38013cyrqx583">
                <CreditCardIcon className={`h-5 w-5 mr-2 ${rt.textPrimary}`} data-id="element-21585" data-mp="3c14j7l9sn19b" />
                Payout Settings
              </h3>
              <div className="space-y-4" data-id="element-21586" data-mp="3gxuzo9pifyv9">
                <div className={`p-3 rounded-lg border ${dk.surfaceMuted} ${dk.border}`} data-id="element-21587" data-mp="3lqo1aopomr34">
                  <p className={`text-sm font-medium ${dk.textPrimary}`} data-id="element-21588" data-mp="2oah9qvk8c3kn">
                    Bank Account
                  </p>
                  <p className={`text-sm ${dk.textMuted}`} data-id="element-21589" data-mp="2t7qva04hzv37">
                    Chase Bank ****4589
                  </p>
                </div>
                <button className={`w-full py-2 border rounded-md text-sm font-medium transition-colors ${dk.card}`} data-id="element-21590" data-mp="3rmposujhnd7i">
                  Update Payout Method
                </button>
              </div>
            </div>

            <div className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-21591" data-mp="58pjdp26rc2x">
              <h3 className={`font-bold mb-4 ${dk.textPrimary}`} data-id="element-21592" data-mp="3dmolz9jnxvpe">
                Tax Documents
              </h3>
              <ul className="space-y-3" data-id="element-21593" data-mp="38p51vt0aaopj">
                {['2022 1099-K Form', '2021 1099-K Form'].map(doc => <li key={doc} className="flex justify-between items-center text-sm" data-id="element-21594" data-mp="3hnqe76f5x7hv">
                    <span className={dk.textSecondary} data-id="element-21595" data-mp="11vazb2zh5fr9">{doc}</span>
                    <button className={`font-medium ${rt.accentLink}`} data-id="element-21596" data-mp="wxribvbe6ovm">
                      Download
                    </button>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Royalties;